module.exports = __webpack_public_path__ + "static/img/eye-open.26bf09f4.svg";